import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import './style.scss'

const PlaylistVocalSettings: FunctionComponent = () => {
  const { t } = useTranslation()

  return (
    <div className="LanguagesSelectionGuide__container">
      <h4 className="LanguagesSelectionGuide__title">
        {t('scheduleCampaignPage.playlistVocalSettings')}
      </h4>
      <p className="LanguagesSelectionGuide__text">
        {t(
          'scheduleCampaignPage.youWillReceiveTracksForReviewOnlyMatchingYourPreferences'
        )}
      </p>

      <h5 className="LanguagesSelectionGuide__subtitle">
        {t('scheduleCampaignPage.noVocal')}
      </h5>

      <p className="LanguagesSelectionGuide__text">
        {t('scheduleCampaignPage.selectIfYouPreferAddInstrumentalMusicOnly')}
      </p>

      <h5 className="LanguagesSelectionGuide__subtitle">
        {t('scheduleCampaignPage.noPreferences')}
      </h5>

      <p className="LanguagesSelectionGuide__text">
        {t('scheduleCampaignPage.selectIfYouAreOpenToAddTracks')}
      </p>

      <h5 className="LanguagesSelectionGuide__subtitle">
        {t('scheduleCampaignPage.language')}
      </h5>

      <p className="LanguagesSelectionGuide__text">
        {t('scheduleCampaignPage.selectLanguageOfTracks')}
      </p>
    </div>
  )
}

export default PlaylistVocalSettings
